export interface Stat {
  number: string;
  label: string;
}

export interface Feature {
  icon: string;
  title: string;
  desc: string;
}

export interface Scenario {
  icon: string;
  title: string;
  desc: string;
}

export interface Comic {
  title: string;
  category: string;
  cover: string;
}

export interface RankingItem {
  title: string;
  category: string;
  heat: string;
}

export interface Review {
  name: string;
  role: string;
  content: string;
  rating: number;
  avatar: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface TimelineItem {
  time: string;
  title: string;
  desc: string;
}

export const stats: Stat[] = [
  { number: '500万+', label: '累计用户' },
  { number: '10万+', label: '优质漫画' },
  { number: '50+', label: '覆盖地区' },
  { number: '99.9%', label: '好评率' },
];

export const features: Feature[] = [
  {
    icon: 'ri-book-open-line',
    title: '海量热门漫画',
    desc: '收录超过10万部漫画，热血、恋爱、悬疑、搞笑全品类覆盖，一次下载，读尽所爱。',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: '智能推荐引擎',
    desc: '基于阅读偏好精准推荐，越用越懂你，让好作品主动找到你，告别漫荒。',
  },
  {
    icon: 'ri-download-cloud-line',
    title: '离线缓存阅读',
    desc: '支持一键缓存整本漫画，无网络也能畅快阅读，通勤旅行零负担。',
  },
  {
    icon: 'ri-palette-line',
    title: '个性化阅读设置',
    desc: '亮度、翻页动画、背景色自由定制，打造专属阅读体验。',
  },
  {
    icon: 'ri-community-line',
    title: '活跃漫友社区',
    desc: '与同好讨论剧情、分享推荐，发现更多宝藏作品。',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步阅读',
    desc: '手机、平板、电脑进度云端同步，换设备也不丢书签。',
  },
];

export const scenarios: Scenario[] = [
  {
    icon: 'ri-train-line',
    title: '通勤路上',
    desc: '地铁公交的碎片时间，几章漫画刚刚好。',
  },
  {
    icon: 'ri-moon-clear-line',
    title: '睡前放松',
    desc: '护眼夜间模式，伴你温柔入眠。',
  },
  {
    icon: 'ri-luggage-cart-line',
    title: '旅行途中',
    desc: '提前缓存整本，离线也能一路畅读。',
  },
  {
    icon: 'ri-time-line',
    title: '碎片时刻',
    desc: '排队、等餐、午休，随时打开随时读。',
  },
];

export const comics: Comic[] = [
  {
    title: '星辰之约',
    category: '恋爱 / 奇幻',
    cover: '/images/comics/comic-1.webp',
  },
  {
    title: '剑影风云',
    category: '热血 / 武侠',
    cover: '/images/comics/comic-2.webp',
  },
  {
    title: '甜心食堂',
    category: '日常 / 治愈',
    cover: '/images/comics/comic-3.webp',
  },
  {
    title: '暗夜猎手',
    category: '悬疑 / 冒险',
    cover: '/images/comics/comic-4.webp',
  },
  {
    title: '青春方程式',
    category: '校园 / 青春',
    cover: '/images/comics/comic-5.webp',
  },
  {
    title: '异世界领主',
    category: '异世界 / 奇幻',
    cover: '/images/comics/comic-6.webp',
  },
];

export const ranking: RankingItem[] = [
  { title: '星辰之约', category: '恋爱 / 奇幻', heat: '9.8 亿人气' },
  { title: '剑影风云', category: '热血 / 武侠', heat: '9.6 亿人气' },
  { title: '异世界领主', category: '异世界 / 奇幻', heat: '9.2 亿人气' },
  { title: '暗夜猎手', category: '悬疑 / 冒险', heat: '8.7 亿人气' },
  { title: '甜心食堂', category: '日常 / 治愈', heat: '8.4 亿人气' },
  { title: '青春方程式', category: '校园 / 青春', heat: '7.9 亿人气' },
  { title: '时光信笺', category: '青春 / 治愈', heat: '7.5 亿人气' },
  { title: '机甲纪元', category: '科幻 / 热血', heat: '7.1 亿人气' },
  { title: '月下怪谈', category: '悬疑 / 志怪', heat: '6.8 亿人气' },
  { title: '美食奇缘', category: '日常 / 美食', heat: '6.3 亿人气' },
];

export const categories: string[] = [
  '热血',
  '恋爱',
  '悬疑',
  '奇幻',
  '校园',
  '治愈',
  '搞笑',
  '科幻',
  '冒险',
  '日常',
  '武侠',
  '异世界',
];

export const reviews: Review[] = [
  {
    name: '小漫迷',
    role: '资深漫迷',
    avatar: '/images/avatars/home-review-1.webp',
    content: '用了天天漫画三年多，界面干净舒服，更新速度也快。每天睡前刷几章，已经是生活的一部分了。',
    rating: 5,
  },
  {
    name: '追番达人',
    role: '通勤族',
    avatar: '/images/avatars/home-review-2.webp',
    content: '阅读体验是我用过的漫画APP里最好的，横竖屏切换流畅、画质清晰，离线缓存对通勤族简直是神器。',
    rating: 5,
  },
  {
    name: '二次元少女',
    role: '内容创作者',
    avatar: '/images/avatars/home-review-3.webp',
    content: '推荐算法太准了，每次打开都能发现宝藏作品。社区氛围也好，可以跟天天漫画APP下载的同好一起讨论剧情。',
    rating: 5,
  },
];

export const faqs: FaqItem[] = [
  {
    q: '天天漫画下载是免费的吗？',
    a: '是的，天天漫画官方正版下载基础功能完全免费，下载应用本身不收取任何费用。部分精品内容提供订阅，你可按需选择。',
  },
  {
    q: '支持哪些设备平台？',
    a: '天天漫画官方正版下载支持 Android、iOS、HarmonyOS 和 Windows 四大平台，手机、平板、电脑均可畅快阅读。',
  },
  {
    q: '离线阅读需要网络吗？',
    a: '缓存完成的漫画无需网络即可阅读，非常适合通勤、旅行等网络不稳定的场景。',
  },
  {
    q: '如何同步多端阅读进度？',
    a: '登录同一账号后，阅读进度会自动云端同步，换设备也能接着上次的章节继续读。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '热门连载每日更新，经典作品稳定连载，具体更新时间以作品详情页展示为准。',
  },
  {
    q: '遇到问题如何联系客服？',
    a: '可在帮助中心提交反馈，或通过天天漫画官方社区留言，我们会尽快为你处理。',
  },
];

export const timeline: TimelineItem[] = [
  {
    time: '06:00',
    title: '清晨连载',
    desc: '晨间漫、日常向作品准时上新',
  },
  {
    time: '12:00',
    title: '午间更新',
    desc: '热门连载集中更新，追更不等待',
  },
  {
    time: '18:00',
    title: '晚间首发',
    desc: '新番首发、独家作品抢先看',
  },
  {
    time: '22:00',
    title: '深夜特辑',
    desc: '治愈系、短篇精选，伴你入眠',
  },
];

export const mascotUrls = {
  hero: '/images/mascot/mascot-hero.webp',
  download: '/images/mascot/mascot-download.webp',
  reading: '/images/mascot/mascot-reading.webp',
  point: '/images/mascot/mascot-point.webp',
  thumbsUp: '/images/mascot/mascot-thumbs.webp',
  celebrate: '/images/mascot/mascot-celebrate.webp',
  sleepy: '/images/mascot/mascot-sleepy.webp',
  wonder: '/images/mascot/mascot-wonder.webp',
  cry: '/images/mascot/cry.png',
  cryClose: '/images/mascot/cry-close.png',
};